module.exports = __webpack_public_path__ + "img/natcash_menu_new.efd3f364.svg";